module.exports = __webpack_public_path__ + "static/img/20250507001.09f2303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20250507001.jpg
// module id = 0g7U
// module chunks = 0